import React from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { Formik } from "formik";
import API from "../../../lib/apiLocal";
import toast from "react-hot-toast";

function ForgetPassword({ passwordShow, setPasswordShow }) {
  return (
    <div>
      <Modal centered show={passwordShow} onHide={() => setPasswordShow(false)}>
        {/* closeButton */}
        <Modal.Header className="px-5 py-4 border-0">
          <Modal.Title as="h2" className="regular">
            Reset Password
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-5 pt-0">
          <Formik
            initialValues={{
              email: "",
              base_url: `${process.env.REACT_APP_FRONTEND_URL}/company-admin-panel`,
            }}
            onSubmit={async (values, { setSubmitting }) => {
              try {
                const resp = await API.post(`/api/user/forgot-password/`,values)
                if(resp){
                  toast.success("A Reset link has been sent to your email ")
                }
              } catch (error) {
                console.log(error)
                toast.error("Something went Wrong")
              }
              setSubmitting(false);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <div>
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-4">
                    <Form.Control
                      type="text"
                      placeholder="Email Id"
                      name="email" // Change "email" to "username"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email || ""}
                    />
                    {errors.email && touched.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </Form.Group>
                  <div className="d-grid">
                    <Button
                      variant="primary"
                      size="lg"
                      type="submit"
                      className="shadow"
                      disabled={isSubmitting}
                    >
                      {!isSubmitting ? "Reset Password" : "Resetting..."}
                    </Button>
                  </div>
                </Form>
              </div>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ForgetPassword; // You need to export the component
